'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$() {
  this.aLV = null;
  this.aLW = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$.prototype = $p;
$p.aA = (function() {
  if ((!this.aLW)) {
    this.aLV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aLW = true;
  }
  return this.aLV;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$, "app.data.data_point_types$package$InvoiceNumber$", ({
  FY: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InvoiceNumber$ };
//# sourceMappingURL=app.data.data_point_types$package$-Invoice-Number$.js.map
